<template>
  <v-row class="d-flex align-center justify-space-around" :class="{filteredBorder: filterActive}">
    <v-col sm="3">
      <TotalPoceduresInfoCard
        :imgSrc="require(`@/assets/icons/blue-heart.png`)"
        title="Total de procedimentos"
        :value="totalProcedures"
      />
    </v-col>
    <v-col sm="3">
      <PatientsRecoveredInfoCard
        :imgSrc="require(`@/assets/icons/green-person-up.png`)"
        title="Pacientes recuperados"
        :value="totalRecovered"
      />
    </v-col>
    <v-col sm="3">
      <DeathsInfoCard
        :imgSrc="require(`@/assets/icons/red-person-down.png`)"
        title="Total de óbitos"
        :value="totalDeaths"
      />
    </v-col>
    <v-col sm="3">
      <TotalTrainingsInfoCard
        :imgSrc="require(`@/assets/icons/blue-medal.png`)"
        title="Total de treinamentos"
        :value="totalTrainings"
      />
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import DeathsInfoCard from "@/components/molecules/Procedimento/deaths-card";
import PatientsRecoveredInfoCard from "@/components/molecules/Procedimento/patients-recovered-card";
import TotalPoceduresInfoCard from "@/components/molecules/Procedimento/total-procedures-card";
import TotalTrainingsInfoCard from "@/components/molecules/Procedimento/total-trainings-card";

export default {
  components: {
    DeathsInfoCard,
    PatientsRecoveredInfoCard,
    TotalPoceduresInfoCard,
    TotalTrainingsInfoCard
  },
  computed: {
    filter() {
      const filterOptions = Object.assign(
        {},
        this.$store.getters.filterProcedimento
      );
      if (filterOptions.startDate) {
        const [year, month, day] = filterOptions.startDate.split("-");
        filterOptions.startDate = `${day}/${month}/${year} 00:00:00`;
        filterOptions.startDate = this.formatDate(filterOptions.startDate);
      }
      if (filterOptions.endDate) {
        const [year, month, day] = filterOptions.endDate.split("-");
        filterOptions.endDate = `${day}/${month}/${year} 23:59:59`;
        filterOptions.endDate = this.formatDate(filterOptions.endDate);
      }
      return filterOptions;
    },
    filteredProcedures() {
      return this.procedures.filter(procedure => {
        if (!this.filter.country) {
          return procedure;
        }
        if (this.filter.country && !this.filter.state)
          return procedure.procedureLocation.country === this.filter.country;
        if (this.filter.country && this.filter.state && !this.filter.city)
          return (
            procedure.procedureLocation.country === this.filter.country &&
            procedure.procedureLocation.state === this.filter.state
          );
        if (
          this.filter.country &&
          this.filter.state &&
          this.filter.city &&
          !this.filter.company
        )
          return (
            procedure.procedureLocation.country === this.filter.country &&
            procedure.procedureLocation.state === this.filter.state &&
            procedure.procedureLocation.city === this.filter.city
          );
        if (
          this.filter.country &&
          this.filter.state &&
          this.filter.city &&
          this.filter.company
        )
          return (
            procedure.procedureLocation.country === this.filter.country &&
            procedure.procedureLocation.state === this.filter.state &&
            procedure.procedureLocation.city === this.filter.city &&
            procedure.procedureLocation.company === this.filter.company
          );
      });
    },
    filteredProceduresByDate() {
      return this.filteredProcedures.filter(procedure => {
        if (this.filter.startDate && !this.filter.endDate)
          return (
            this.formatDate(procedure.procedureDatetime) > this.filter.startDate
          );
        if (!this.filter.startDate && this.filter.endDate)
          return (
            this.formatDate(procedure.procedureDatetime) < this.filter.endDate
          );
        if (this.filter.startDate && this.filter.endDate)
          return (
            this.formatDate(procedure.procedureDatetime) >
              this.filter.startDate &&
            this.formatDate(procedure.procedureDatetime) < this.filter.endDate
          );
        return procedure;
      });
    },
    totalDeaths() {
      return this.filteredProceduresByDate.filter(
        procedure => !procedure.patientSaved
      ).length;
    },
    totalProcedures() {
      return this.filteredProceduresByDate.length;
    },
    totalRecovered() {
      return this.filteredProceduresByDate.filter(
        procedure => procedure.patientSaved
      ).length;
    },
    totalTrainings() {
      return this.filteredProceduresByDate.filter(
        procedure => procedure.procedureType === "training"
      ).length;
    }
  },
  methods: {
    formatDate(value) {
      return moment(value, [
        "DD-MM-YYYY HH:mm:ss",
        "YYYY-MM-DDTHH:mm:ss.SSSSZ"
      ]);
    }
  },
  props: {
    procedures: {
      type: Array,
      required: true
    },
    filterActive: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.filteredBorder {
  border: 2px solid #6464ff;
  border-radius: 10px;
}
</style>